/* Subumi "Find your device" component.
   - Modal (snippets/subumi-device-modal.liquid) opened by any .subumi-device-trigger
   - Selection persists in localStorage("subumi_device") as {key,label,url}
   - Product cards carrying data-subumi-tags get a "FITS YOUR {DEVICE}" badge when
     their device: tags match, and are dimmed when they have device tags that all
     mismatch. Cards without device tags are left alone (taxonomy rollout is gradual).
   - PDP: pre-selects the variant pill matching the stored device when nothing
     else is selected (cooperates with subumi-variant-guard.js via a click). */
(function () {
  var STORAGE_KEY = 'subumi_device';

  /* Maps a device key to a regex matched against variant option values. */
  var VARIANT_PATTERNS = {
    'ps5': /(playstation 5|ps5)(?!.*slim).*standard|^(playstation 5|ps5) (disc|digital)/i,
    'ps5-slim': /slim/i,
    'xbox-x': /series\s*-?\s*x/i,
    'xbox-s': /series\s*-?\s*s/i
  };

  function getDevice() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return null;
    }
  }

  function setDevice(device) {
    try {
      if (device && device.key) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(device));
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      /* private mode: selection just won't persist */
    }
  }

  /* ----- Modal ----- */
  function initModal() {
    var modal = document.getElementById('SubumiDeviceModal');
    if (!modal) return;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.subumi-device-trigger');
      if (trigger) {
        e.preventDefault();
        modal.hidden = false;
        document.body.classList.add('subumi-modal-open');
      }
      if (e.target.closest('[data-device-close]')) {
        modal.hidden = true;
        document.body.classList.remove('subumi-modal-open');
      }
      var pick = e.target.closest('[data-device-key]');
      if (pick) {
        setDevice({
          key: pick.dataset.deviceKey,
          label: pick.dataset.deviceLabel,
          url: pick.dataset.deviceUrl
        });
        window.location.href = pick.dataset.deviceUrl;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        modal.hidden = true;
        document.body.classList.remove('subumi-modal-open');
      }
    });
  }

  /* ----- Card badges ----- */
  function decorateCards(device) {
    if (!device || !device.key) return;
    document.querySelectorAll('[data-subumi-tags]').forEach(function (card) {
      if (card.dataset.subumiDecorated) return;
      var tags = card.dataset.subumiTags.toLowerCase().split(',');
      var deviceTags = tags.filter(function (t) { return t.indexOf('device:') === 0; });
      if (!deviceTags.length) return;
      card.dataset.subumiDecorated = '1';
      var fits = deviceTags.indexOf('device:' + device.key) !== -1;
      if (fits) {
        var badge = document.createElement('span');
        badge.className = 'subumi-fit-badge';
        badge.textContent = 'FITS YOUR ' + device.label;
        var media = card.querySelector('.card__media') || card;
        media.appendChild(badge);
      } else {
        card.classList.add('subumi-unfit');
      }
    });
  }

  /* ----- PDP variant pre-select ----- */
  function preselectVariant(device) {
    if (!device || !device.key) return;
    var pattern = VARIANT_PATTERNS[device.key];
    if (!pattern) return;
    document.querySelectorAll('variant-selects').forEach(function (picker) {
      var radios = picker.querySelectorAll(".product-form__input--pill input[type='radio']");
      if (!radios.length) return;
      var anyChecked = Array.prototype.some.call(radios, function (r) { return r.checked; });
      if (anyChecked) return;
      for (var i = 0; i < radios.length; i++) {
        if (pattern.test(radios[i].value) && !radios[i].classList.contains('disabled')) {
          radios[i].click();
          break;
        }
      }
    });
  }

  function init() {
    initModal();
    var device = getDevice();
    decorateCards(device);
    preselectVariant(device);
    /* re-decorate after section re-renders (filters, pagination, drawers) */
    var observer = new MutationObserver(function () {
      decorateCards(getDevice());
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
